import $ from 'jquery';
import '../js/common';
import caculator from './caculator';
import aosSetup from './aos-config';

import '../css/header.css';
import '../css/navi.css';
import '../css/tabs.css';
import '../css/sharing.css';
import '../css/warning.css';
import '../css/page/index.css';
import '../css/page/index-1.css';

let winW;

const section1Flower = () => {
	const flowerZoom = caculator(768, 385, 1, 0.6, winW);
	const flower1Left = caculator(768, 385, 78, 48, winW);
	const flower1Bottom = caculator(768, 385, 440, 380, winW);
	const flower2Right = caculator(768, 385, 25, 5, winW);
	const flower2Bottom = caculator(768, 385, 610, 530, winW);
	$(`.section-1-flower-1`).css({ left: flower1Left, zoom: flowerZoom, bottom: `${flower1Bottom}px` });
	$(`.section-1-flower-2`).css({ right: flower2Right, zoom: flowerZoom, bottom: `${flower2Bottom}px` });
};

const section2Flower = () => {
	const flowerZoom = caculator(768, 385, 1, 0.6, winW);
	const flowerLeft = caculator(768, 385, 120, 100, winW);
	const flowerBottom = caculator(768, 385, 440, 370, winW);
	$(`.section-2-flower`).css({ left: flowerLeft, zoom: flowerZoom, bottom: `${flowerBottom}px` });
};

const section3Deco = () => {
	const deceBaseMarginLeft = caculator(768, 385, 0, -160, winW);
	const cardMargin = caculator(768, 385, 70, -50, winW);
	const card3Margin = caculator(768, 385, 0, -50, winW);
	$('.section-3-deco .deco-base').css({ 'margin-left': `${deceBaseMarginLeft}px` });
	$('.section-3-info-4, .section-3-info-5').css({ 'margin-right': `${cardMargin}px` });
	$('.section-3-info-2').css({ 'margin-left': `${cardMargin}px` });
	$('.section-3-info-3').css({ 'margin-left': `${card3Margin}px` });
};

const unsetStyle = () => {
	$(`.section-1-flower-1,
		.section-1-flower-2,
		.section-2-flower,
		.section-3-deco .flower,
		.section-3-info-2,
		.section-3-info-3,
		.section-3-info-4,
		.section-3-info-5`).removeAttr('style');
};

const setJsLayout = () => {
	if (winW <= 768) {
		section1Flower();
		section2Flower();

		if (winW > 480) {
			section3Deco();
		} else {
			$(`.section-3-info-2,
				.section-3-info-3,
				.section-3-info-4,
				.section-3-info-5`).removeAttr('style');
		}

		return;
	}

	unsetStyle();
};

const getWindowData = () => {
	winW = $(window).width();
};

$(window).resize(() => {
	getWindowData();

	setJsLayout();
});

$(document).ready(() => {
	getWindowData();

	setJsLayout();
});

aosSetup();



// WEBPACK FOOTER //
// ./src/js/index.js